import React, { Component } from "react";
import { Button, Input, Checkbox, Messages } from "../components/ui";
import AuthService from "../services/AuthService";
import { Check } from "lucide-react";

function maskCPF(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 9) {
    return v.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
  } else if (v.length > 6) {
    return v.replace(/^(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
  } else if (v.length > 3) {
    return v.replace(/^(\d{3})(\d{1,3})/, "$1.$2");
  }
  return v;
}

function maskPhone(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 10) {
    return v.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (v.length > 6) {
    return v.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (v.length > 2) {
    return v.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  }
  return v;
}

function validateCPF(cpfStr) {
  let strCPF = (cpfStr || "").replace(/[^\d]+/g, "");
  if (strCPF === "" || strCPF.length !== 11 || /^(\d)\1{10}$/.test(strCPF))
    return false;
  let soma = 0;
  for (let i = 1; i <= 9; i++)
    soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

class CompletarPerfil extends Component {
  constructor() {
    super();
    this.state = {
      cpf: "",
      telefone: "",
      is_maior_idade: false,
      loading: false,
    };
    this.msg = React.createRef();
    this.authService = new AuthService();
  }

  componentDidMount() {
    const userId = sessionStorage.getItem("brv-user-id");
    if (!userId) {
      window.location.replace("/login");
    }
  }

  showMessage = (severity, summary, detail) => {
    if (!this.msg.current) return;
    this.msg.current.clear();
    this.msg.current.show([{ severity, summary, detail }]);
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { cpf, telefone, is_maior_idade, loading } = this.state;

    if (loading) return;

    const cleanCpf = (cpf || "").replace(/\D/g, "");
    if (!cleanCpf) {
      this.showMessage("error", "Erro!", "A conclusão do cadastro não pode ser realizada sem o CPF.");
      return;
    }

    if (!validateCPF(cleanCpf)) {
      this.showMessage("error", "Erro!", "Digite um CPF válido para concluir o cadastro.");
      return;
    }

    const cleanTelefone = (telefone || "").replace(/\D/g, "");
    if (!cleanTelefone) {
      this.showMessage("error", "Erro!", "A conclusão do cadastro não pode ser realizada sem o telefone.");
      return;
    }

    if (cleanTelefone.length < 10) {
      this.showMessage(
        "error",
        "Erro!",
        "Digite um telefone válido com DDD (mínimo 10 dígitos) para concluir o cadastro."
      );
      return;
    }

    const userId = sessionStorage.getItem("brv-user-id");
    if (!userId) {
      this.showMessage(
        "error",
        "Erro!",
        "Usuário não identificado. Por favor, refaça o login."
      );
      setTimeout(() => {
        window.location.replace("/login");
      }, 2000);
      return;
    }

    this.setState({ loading: true });
    this.showMessage("info", "Aguarde", "Salvando informações de perfil...");

    const data = {
      telefone1: cleanTelefone,
      telefone: cleanTelefone,
      cpf: cleanCpf,
      is_maior_idade: is_maior_idade,
      id_usuario: parseInt(userId),
    };

    try {
      let response = await this.authService.setInfoAdicional(
        JSON.stringify(data)
      );

      // Registro de info adicional já existe → atualiza via endpoint de update
      if (response.status === 400) {
        response = await this.authService.updateInfoAdicional(
          parseInt(userId),
          { cpf: cleanCpf, telefone: cleanTelefone, telefone1: cleanTelefone, is_maior_idade }
        );
      }

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      this.showMessage("success", "Sucesso!", "Perfil completado com sucesso!");

      const userType =
        sessionStorage.getItem("brv-tipo-user") || "Corredor";
      const redirectPath =
        userType === "Organizador" ? "/dashboard" : "/minhas-corridas";

      setTimeout(() => {
        window.location.replace(redirectPath);
      }, 1000);
    } catch (err) {
      console.error(err);
      this.showMessage(
        "error",
        "Erro!",
        "Não foi possível salvar os dados do perfil. Tente novamente."
      );
      this.setState({ loading: false });
    }
  };

  render() {
    const { cpf, telefone, is_maior_idade, loading } = this.state;
    const cleanCpf = (cpf || "").replace(/\D/g, "");
    const cleanPhone = (telefone || "").replace(/\D/g, "");
    const isFormValid = cleanCpf.length === 11 && cleanPhone.length >= 10;

    return (
      <div className="min-h-screen flex items-center justify-center bg-urb-dark py-12 px-4 selection:bg-urb-primary selection:text-black">
        <div className="w-full max-w-md bg-urb-card/90 border border-urb-border rounded-3xl p-8 shadow-2xl flex flex-col items-center gap-6">
          <div className="flex flex-col gap-2 text-center items-center">
            <img
              src={require("../statics/img/VERDE-3.png")}
              alt="Logo"
              className="w-24 h-24 object-contain"
            />
            <h2 className="text-2xl font-black leading-tight text-white mt-2">
              Complete seu Perfil
            </h2>
            <p className="text-xs text-slate-400 m-0 max-w-xs leading-relaxed">
              Falta pouco! Precisamos de alguns dados adicionais para concluir o
              seu cadastro.
            </p>
          </div>

          <div className="w-full">
            <Messages ref={this.msg} />

            <form onSubmit={this.handleSubmit} className="flex flex-col gap-4 mt-2">
              <div className="flex flex-col gap-1.5 text-left">
                <label
                  htmlFor="cpf"
                  className="text-xs font-semibold text-slate-300"
                >
                  CPF <span className="text-red-500">*</span>
                </label>
                <Input
                  id="cpf"
                  type="text"
                  placeholder="000.000.000-00"
                  value={cpf}
                  maxLength="14"
                  onChange={(e) =>
                    this.setState({ cpf: maskCPF(e.target.value) })
                  }
                  required
                />
              </div>

              <div className="flex flex-col gap-1.5 text-left">
                <label
                  htmlFor="telefone"
                  className="text-xs font-semibold text-slate-300"
                >
                  Telefone <span className="text-red-500">*</span>
                </label>
                <Input
                  id="telefone"
                  type="text"
                  placeholder="(00) 00000-0000"
                  value={telefone}
                  maxLength="15"
                  onChange={(e) =>
                    this.setState({
                      telefone: maskPhone(e.target.value),
                    })
                  }
                  required
                />
              </div>

              <div className="flex items-center gap-2.5 mt-1 text-left">
                <Checkbox
                  id="maior_idade"
                  checked={is_maior_idade}
                  onChange={(e) =>
                    this.setState({ is_maior_idade: e.checked })
                  }
                />
                <label
                  htmlFor="maior_idade"
                  className="text-xs text-slate-300 font-medium cursor-pointer"
                >
                  Declaro que sou maior de idade
                </label>
              </div>

              <div className="mt-3">
                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  className="w-full font-black text-sm uppercase py-3.5 tracking-wider flex items-center justify-center gap-2 shadow-lg"
                  loading={loading}
                  disabled={loading || !isFormValid}
                >
                  <Check className="w-4 h-4" />
                  Salvar e Continuar
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CompletarPerfil;
